var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09655 3.81335C9.17834 3.73136 9.27549 3.66631 9.38246 3.62192C9.48942 3.57753 9.60409 3.55469 9.7199 3.55469C9.83571 3.55469 9.95038 3.57753 10.0573 3.62192C10.1643 3.66631 10.2615 3.73136 10.3432 3.81335L20.9085 14.3786C20.9905 14.4604 21.0555 14.5575 21.0999 14.6645C21.1443 14.7714 21.1671 14.8861 21.1671 15.0019C21.1671 15.1177 21.1443 15.2324 21.0999 15.3394C21.0555 15.4463 20.9905 15.5435 20.9085 15.6253L10.3432 26.1905C10.1779 26.3558 9.9537 26.4487 9.7199 26.4487C9.4861 26.4487 9.26187 26.3558 9.09655 26.1905C8.93123 26.0252 8.83835 25.8009 8.83835 25.5671C8.83835 25.3333 8.93123 25.1091 9.09655 24.9438L19.0402 15.0019L9.09655 5.06004C9.01456 4.97826 8.94951 4.8811 8.90512 4.77414C8.86074 4.66717 8.83789 4.5525 8.83789 4.4367C8.83789 4.32089 8.86074 4.20622 8.90512 4.09925C8.94951 3.99229 9.01456 3.89513 9.09655 3.81335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/ArrowRightIcon.9ba073b107eba3b1219a5387f08daa3f.svg";
export { ForwardRef as ReactComponent };